export const triggerDownload = downloadUrl => {
  const link = document.createElement('a')
  link.href = downloadUrl
  link.setAttribute('download', '')
  document.body.appendChild(link)
  link.click()
  link.remove()
}
